import React from 'react'

// Components
import Text from 'components/flex/Text/Text'
import TextImage from 'components/flex/Text/TextImage'
import TextCta from 'components/flex/Text/TextCta'
import TextRecentPosts from 'components/flex/Text/TextRecentPosts'
import TextForm from 'components/flex/Text/TextForm'
import TextTwoColumnsImage from 'components/flex/Text/TextTwoColumnsImage'
import TextTwoColumns from 'components/flex/Text/TextTwoColumns'
import TextFourColumns from 'components/flex/Text/TextFourColumns'
import TextWorkday from 'components/flex/Text/TextWorkday'
import TextMaintenance from './TextMaintenance'
import TextVideo from './TextVideo'

export interface TextProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Text
  location?: any
  pageContext?: any
}

interface PostProps {
  [key: string]: any
}

const TextShell: React.FC<TextProps> = ({
  fields,
  location = {},
  pageContext,
}) => {
  const types: PostProps = {
    default: Text,
    image: TextImage,
    video: TextVideo,
    cta: TextCta,
    recentposts: TextRecentPosts,
    form: TextForm,
    maintenance: TextMaintenance,
    columns_image: TextTwoColumnsImage,
    two_columns: TextTwoColumns,
    four_coumns: TextFourColumns,
    workdays: TextWorkday,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
      pageContext={pageContext}
    />
  )
}

export default TextShell
